import { render } from "./TalkPage.vue?vue&type=template&id=65167cc8&scoped=true"
import script from "./TalkPage.vue?vue&type=script&lang=js"
export * from "./TalkPage.vue?vue&type=script&lang=js"

import "./TalkPage.vue?vue&type=style&index=0&id=65167cc8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65167cc8"]])

export default __exports__